export enum TokenProjectsEnum {
  BRL = "BRL",
  GOLD = "GOLD",
}
